var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { position: "relative" } },
    [
      _c(
        "van-nav-bar",
        {
          attrs: {
            title: _vm.title,
            "left-text": _vm.leftText,
            "left-arrow": _vm.leftArrow && !_vm.isShowOverlay,
            "right-text": _vm.rightText
          },
          on: { "click-left": _vm.leftClick, "click-right": _vm.rightClick }
        },
        [
          _c("template", { slot: "title" }, [_vm._t("title")], 2),
          _vm._v(" "),
          !_vm.isShowOverlay
            ? _c("template", { slot: "right" }, [_vm._t("right")], 2)
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }